import { useThree } from '@react-three/fiber';
import { PerspectiveCamera } from 'three';

function useCamera(): PerspectiveCamera {
  const camera = useThree((state) => state.camera);
  return camera as PerspectiveCamera;
}

export default useCamera;
